import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { spacing, colors } from '@chegg-ui/theme';
import { SecondaryLink } from '@chegg-ui/link';
import { getMediaQueryV2 } from '@chegg-me-lpc/utils';
import styled from 'styled-components';
export var PrimaryNavContainer = styled.div.withConfig({
  componentId: "sc-1dzksp6-0"
})(["width:100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;padding:", " 0;border-bottom:1px solid ", ";", " ", ""], spacing.px24, colors.grey300, getMediaQueryV2.lgAndHigher(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "]))), getMediaQueryV2.mdAndLower(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]))));
export var PrimaryNavLink = styled(SecondaryLink).withConfig({
  componentId: "sc-1dzksp6-1"
})(["padding:", " ", ";"], spacing.px4, spacing.px8);
export var PrimaryNavContent = styled.div.withConfig({
  componentId: "sc-1dzksp6-2"
})(["display:flex;align-items:center;flex-wrap:wrap;justify-content:center;"]);